<template>
  <div class="h-40 md:h-[344px] w-full md:w-[615px] mx-auto overflow-hidden rounded-2xl">
    <iframe
        class="w-full h-full"
        :src="embedUrl"
        title="Video Player"
        frameborder="0"
        allowfullscreen
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  videoId: {
    type: String,
    required: true,
  }
})

const embedUrl = computed(() => `https://videodelivery.net/${props.videoId}/iframe`)
</script>